import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

// Prevent multiple simultaneous logouts
let isLoggingOut = false;

export const useApi = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleError = (error) => {
    // Check if it's an authentication error
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Prevent multiple simultaneous logouts
      if (!isLoggingOut) {
        isLoggingOut = true;
        logout();
        navigate('/login');
        // Reset flag after a delay
        setTimeout(() => {
          isLoggingOut = false;
        }, 1000);
      }
      throw new Error('Session expired. Please login again.');
    }
    throw error;
  };

  return {
    get: async (url) => {
      try {
        const token = localStorage.getItem('auth_token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.get(`${API_URL}${url}`, { headers });
        return res.data;
      } catch (error) {
        handleError(error);
      }
    },
    post: async (url, data) => {
      try {
        const token = localStorage.getItem('auth_token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.post(`${API_URL}${url}`, data, { headers });
        return res.data;
      } catch (error) {
        handleError(error);
      }
    },
    put: async (url, data) => {
      try {
        const token = localStorage.getItem('auth_token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.put(`${API_URL}${url}`, data, { headers });
        return res.data;
      } catch (error) {
        handleError(error);
      }
    },
    patch: async (url, data) => {
      try {
        const token = localStorage.getItem('auth_token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.patch(`${API_URL}${url}`, data, { headers });
        return res.data;
      } catch (error) {
        handleError(error);
      }
    },
    delete: async (url) => {
      try {
        const token = localStorage.getItem('auth_token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await axios.delete(`${API_URL}${url}`, { headers });
        return res.data;
      } catch (error) {
        handleError(error);
      }
    },
  };
};
